import { debounce } from "@mui/material";
import { NumberFormatValues, NumericFormat, NumericFormatProps } from "react-number-format";
import { convertToFloatWithDefaultPrecision, convertToFloatWithMinimumPrecision } from "src/const/Units";

interface CustomProps {
  onChange: (event: { target: { name: string; value: number } }) => void;
  name: string;
  value: number;
}

const InputPercentage = React.forwardRef<NumericFormatProps, CustomProps>(
  function NumericFormatCustom(props, ref) {
    const { onChange, ...other } = props;
    
    const onValueChangeHandler = debounce((values: NumberFormatValues) => {
      onChange({
        target: {
          name: props.name,
          value: convertToFloatWithDefaultPrecision(values.floatValue / 100),
        },
      });
    }, 200)    

    return (
      <NumericFormat
        {...other}
        getInputRef={ref}
        decimalSeparator=","
        onValueChange={onValueChangeHandler}
        allowNegative={false}
        decimalScale={2}
        suffix='%'
      />
    );
  },
);

/**
 * Use in Datagrid _percentage_renderEditCell / GridEditInputCell
 */
export const InputPercentageTable = React.forwardRef<NumericFormatProps, CustomProps>(
  function NumericFormatCustom(props, ref) {
    const { onChange, ...other } = props;
    const value: number|string = props.value;
    
    const onValueChangeHandler = debounce((values: NumberFormatValues) => {
      typeof values.floatValue != "undefined" && onChange({
        target: {
          name: props.name,
          value: values.floatValue / 100,
        },
      });
    }, 200)    

    return (
      <NumericFormat
        {...other}
        value={typeof value != "undefined" && typeof value != "string" && value ? convertToFloatWithMinimumPrecision(value * 100) : null}
        getInputRef={ref}
        decimalSeparator=","
        onValueChange={onValueChangeHandler}
        allowNegative={false}
        decimalScale={2}
        suffix='%'
      />
    );
  },
);
export default InputPercentage
